;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .controller('CollectionItemController', CollectionItemController)

  /* @ngInject */
  function CollectionItemController ($scope, $translate, $q, $rootScope, $state, $location, Utils, CONSTANTS, ArtCollectionsService, ModalService, SegmentService, ToastService, ConfirmationModalService, CampaignService, UdsModalService, CustomerConfigurationsService) {
    const getCreateCampaignDialogController = () => $q.when(import('../../../admin/dialogs/create-campaign/create-campaign-dialog.controller'))
    const getMoveTemplateCollectionController = () => $q.when(import('../../dialogs/move-template-collection/move-template-collection-dialog.controller'))
    const getShareFolderDialogController = () => $q.when(import('../../../arts/dialogs/share-folder/share-folder-dialog.controller'))

    $scope.showHighlightButton = false
    $scope.isScheduled = false
    $scope.isExpired = false
    $scope.userIsSysAdminAdminDesigner = $rootScope.isUserSysAdminAdminDesigner()
    $scope.archiveText = ''
    $scope.publicFolderIsEnabled = false

    const api = {
      getCreateCampaignDialogController,
      getMoveTemplateCollectionController,
      getShareFolderDialogController,
      _getStandardBackground,
      _emitReloadPage,
      _unbindArtCollectionFromCampaign,
      _archiveCollection,
      _unarchiveCollection
    }

    this.getApi = () => api

    activate()

    function activate () {
      if ($scope.collection) {
        if ($scope.collection.isArchived) {
          $scope.archiveText = $translate.instant('unarchive')
        } else {
          $scope.archiveText = $translate.instant('archive')
        }

        $scope.showHighlightButton = !$scope.collection.highlighted

        if ($scope.collection.scheduledDate) {
          const now = moment()
          const scheduledDate = moment($scope.collection.scheduledDate)

          $scope.isScheduled = scheduledDate > now
        }

        if ($scope.collection.expirationDate) {
          const now = moment()
          const expirationDate = moment($scope.collection.expirationDate)
          $scope.isExpired = expirationDate < now
        }
      }

      $rootScope.getCompanyFeatures().then(features => {
        if (features.includes('PUBLIC_FOLDER')) {
          $scope.publicFolderIsEnabled = true
        }
      })
    }

    $scope.showScheduleDate = function (collection) {
      const scheduleDate = new Date(collection.scheduledDate)
      const now = new Date()
      if (collection.scheduledDate && scheduleDate > now) {
        return true
      }
      return false
    }

    $scope.formatDate = (dateISO = new Date()) => {
      const configOptions = {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      }

      const locale = $rootScope.oUser.locale
      const date = new Date(dateISO)
      const formattedDate = new Intl.DateTimeFormat(locale, configOptions).format(date)
      return formattedDate.replace(/ de /g, ' ')
    }

    $scope.getCollectionThumbnailUrl = function (collection) {
      if (collection.thumbnailUrl) {
        return collection.thumbnailUrl
      }
      let src
      if (collection.thumbnailS3Key) {
        if ($scope.isPublicCampaign) {
          const url = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_SHARE_LINKS_THUMBNAIL_ID_COLLECTION, [collection.id, $scope.linkUuid])
          src = Utils.fnAddQueryToUrl(url, { cache: collection.updatedAt })
        } else {
          const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_THUMBNAIL, [collection.id])
          src = Utils.fnAddQueryToUrl(url, { cache: collection.updatedAt })
        }

        return src
      }

      if (collection.random_template && collection.random_template.id) {
        if ($scope.isPublicCampaign) {
          src = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_SHARE_LINKS_THUMBNAIL_ID, [collection.random_template.id, $scope.linkUuid])
        } else {
          src = Utils.fnReplaceStringParams(CONSTANTS.URL_TEMPLATES_ID_THUMBNAIL, [collection.random_template.id])
        }
      } else if (collection.templates?.length) {
        if ($scope.isPublicCampaign) {
          src = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_SHARE_LINKS_THUMBNAIL_ID, [collection.templates[0], $scope.linkUuid])
        } else {
          src = Utils.fnReplaceStringParams(CONSTANTS.URL_TEMPLATES_ID_THUMBNAIL, [collection.templates[0]])
        }
      } else if ((collection.templates && !collection.templates.length) || (!collection.templates)) {
        src = api._getStandardBackground()
      }

      return src
    }

    $scope.editCollectionClick = function (collection) {
      api.getCreateCampaignDialogController().then(({ CreateCampaignDialogController }) => {
        ModalService.showModal({
          templateId: 'createCampaign.html',
          templateUrl: '/admin/dialogs/create-campaign/create-campaign-dialog.html?$$REVISION$$',
          destroyable: true,
          observeChanges: true,
          allowMultiple: true,
          controller: CreateCampaignDialogController,
          data: {
            collection,
            artCollectionId: collection.parentId
          }
        }).then(changed => {
          $scope.collectionParam.id = collection.id
          if (changed && !$scope.isProductList) {
            api._emitReloadPage()
          } else if (changed && $scope.isProductList) {
            $scope.$emit('refresh-arts-page', { sectionId: collection.parentId })
          }
        })
      })
    }

    $scope.highlightCollectionClick = function (collection) {
      if (!collection.thumbnailS3Key) {
        ToastService.showErrorToast($translate.instant('requireThumbnailMessage'))
        return
      }

      ArtCollectionsService.highlightArtCollection(collection.id, true)
        .catch(ToastService.defaultErrorToast)
        .then(() => {
          SegmentService.track('arts-collection-highlight', { collection_id: collection.id, is_highlight: true })
          if (!$scope.isProductList) {
            api._emitReloadPage('highlightCollection', { old: { sectionId: collection?.parentId } })
          } else {
            $scope.$emit('refresh-arts-page', { sectionId: collection?.parentId })
          }
        })
    }

    $scope.moveToClick = function (collection) {
      return api.getMoveTemplateCollectionController().then(({ MoveTemplateCollectionController }) => {
        ModalService.showModal({
          templateId: 'moveTemplateCollection.html',
          templateUrl: '/arts/dialogs/move-template-collection/move-template-collection-dialog.html?$$REVISION$$',
          destroyable: true,
          observeChanges: true,
          allowMultiple: true,
          controller: MoveTemplateCollectionController,
          data: {
            data: collection,
            type: 'collection'
          }
        }).then(info => {
          if (info && info.changed && !$scope.isProductList) {
            api._emitReloadPage('moveCollection', { in: info?.in, to: info?.to })
          } else if (info && info.changed && $scope.isProductList) {
            $scope.$emit('refresh-arts-page', { sectionId: info?.in, targetId: info?.to })
          }
        })
      })
    }

    $scope.archiveCollectionClick = function (collection) {
      const modalConfig = {
        title: $translate.instant('archive'),
        buttonCancelText: $translate.instant('cancel'),
        buttonConfirmText: $translate.instant('campaignEdit.archiveConfirm.confirm'),
        onConfirm: () => {
          api._archiveCollection(collection)
        }
      }

      if (collection.campaignId) {
        modalConfig.htmlDescription = CampaignService.getArchiveHtmlDescription(collection.campaignName)
      } else {
        modalConfig.description = $translate.instant('areYouSureArchiveCollection')
      }

      ConfirmationModalService.createModal(modalConfig)
    }

    function _archiveCollection (collection) {
      ArtCollectionsService.archiveArtCollection(collection.id).then(() => {
        $scope.collectionParam = { ...$scope.collectionParam, id: collection.id }
        ToastService.defaultSuccessToast()
        if (!$scope.isProductList) {
          api._emitReloadPage('archiveCollection', { sectionId: collection?.parentId, highlighted: collection?.highlighted })
        } else {
          $scope.$emit('refresh-arts-page', { sectionId: collection?.parentId })
        }
      }).catch(ToastService.defaultErrorToast)
    }

    function _unarchiveCollection (collection) {
      ArtCollectionsService.unarchiveArtCollection(collection.id).then(() => {
        api.getMoveTemplateCollectionController().then(({ MoveTemplateCollectionController }) => {
          ModalService.showModal({
            templateId: 'moveTemplateCollection.html',
            templateUrl: '/arts/dialogs/move-template-collection/move-template-collection-dialog.html?$$REVISION$$',
            destroyable: true,
            observeChanges: true,
            allowMultiple: true,
            controller: MoveTemplateCollectionController,
            data: {
              data: collection,
              type: 'collection'
            }
          }).then(info => {
            if (info && info.changed) {
              api._emitReloadPage('moveCollection', { in: info?.in, to: info?.to })
            }
          })
        })
      }).catch(() => {
        ToastService.defaultErrorToast()
      })
    }

    $scope.unarchiveCollectionClick = function (collection) {
      const modalConfig = {
        title: $translate.instant('archiveUnarchiveCollectionDialog.title'),
        buttonCancelText: $translate.instant('cancel'),
        buttonConfirmText: $translate.instant('archiveUnarchiveCollectionDialog.buttonUnarchive'),
        description: $translate.instant('archiveUnarchiveCollectionDialog.descriptionUnarchive'),
        onConfirm: () => {
          api._unarchiveCollection(collection)
        }
      }

      ConfirmationModalService.createModal(modalConfig)
    }

    $scope.removeHighlightCollectionClick = function (collection) {
      return api.getMoveTemplateCollectionController().then(({ MoveTemplateCollectionController }) => {
        ModalService.showModal({
          templateId: 'moveTemplateCollection.html',
          templateUrl: '/arts/dialogs/move-template-collection/move-template-collection-dialog.html?$$REVISION$$',
          destroyable: true,
          observeChanges: true,
          allowMultiple: true,
          controller: MoveTemplateCollectionController,
          data: {
            data: collection,
            type: 'collection',
            onlyTarget: true
          }
        }).then(info => {
          if (info && info.artCollectionId) {
            ArtCollectionsService.highlightArtCollection(collection.id, false, info.artCollectionId).then(() => {
              SegmentService.track('arts-collection-highlight', { collection_id: collection.id, is_highlight: false })
              ModalService.close(true)
              ToastService.defaultSuccessToast()
              api._emitReloadPage()
            }).catch(ToastService.defaultErrorToast)
          } else {
            ModalService.close()
          }
        })
      })
    }

    $scope.notifyMembers = function (collectionId) {
      ArtCollectionsService.notificateMembers(collectionId).then(ToastService.defaultSuccessToast).catch(ToastService.defaultErrorToast)
    }

    $scope.openBindCampaignDialog = (collection) => {
      const onClose = (bindDetails) => {
        if (bindDetails) {
          api._unbindArtCollectionFromCampaign(bindDetails, collection)
        }
      }

      CampaignService.openUnbindCampaignDialog(collection, 'arts', onClose)
    }

    function _unbindArtCollectionFromCampaign (bindDetails, collection) {
      ArtCollectionsService.unbindArtCollectionFromCampaign({ campaignId: collection.campaignId, artCollectionId: collection.id })
        .then(() => {
          ToastService.defaultSuccessToast()
          $scope.$emit('reload-arts-page', { campaignId: collection.campaignId })
        })
        .catch(() => {
          ToastService.defaultErrorToast()
        })
    }

    function _getStandardBackground () {
      return '/assets/icons/empty-collection.svg'
    }

    $scope.canUnbindCampaign = function (collection) {
      const hasCampaignAccess = !!$rootScope.companyFeaturesAndAddons.features['CAMPAIGNS.ACCESS']
      const isAdminOrDesigner = $rootScope.isUserSysAdminAdmin()
      const hasActiveCampaign = (collection.campaignId && collection.isActiveInCampaign !== false)

      return hasCampaignAccess && isAdminOrDesigner && hasActiveCampaign
    }

    function _emitReloadPage (emitter = 'default', data = {}) {
      $scope.$emit('reload-arts-page', { emitter, ...data })
    }

    $scope.handleDoubleClickOnCard = (collection) => {
      if ($scope.isPublicCampaign) {
        $scope.onCardDoubleClick(collection.id)
        return
      }

      if ($rootScope.isUserSysAdminAdminDesigner()) {
        let root = null
        if (collection.parentId && !collection.highlighted) {
          root = collection.parentId
        }

        const currentState = $state.current.name
        const currentUrlParams = $location.search()
        const isCurrentPageInEditMode = currentState === 'arts.templatesEdit' || currentUrlParams.edit

        $rootScope.$emit('arts.clear-arts-filters')
        $state.go('arts.collection', {
          id: collection.id,
          pageHistory: [],
          root,
          isArchived: collection.isArchived,
          edit: isCurrentPageInEditMode
        })
      }

      if ($rootScope.isUserSysAdminAdminDesigner()) {
        const currentState = $state.current.name
        const currentUrlParams = $location.search()
        const isCurrentPageInEditMode = currentState === 'arts.templatesEdit' || currentUrlParams.edit

        $rootScope.$emit('arts.clear-arts-filters')
        $state.go('arts.collection', {
          id: collection.id,
          pageHistory: [],
          root,
          isArchived: collection.isArchived,
          edit: isCurrentPageInEditMode
        })
      } else {
        $state.go('user.collection', { id: collection.id }, { reload: true })
      }
    }

    $scope.handleCardClick = (collection, event) => {
      $scope.onCardClick({ collection, event })
    }

    $scope.shareCollectionClick = function (collection) {
      api.getShareFolderDialogController().then(({ ShareFolderDialogController }) => {
        const shareFolderDialog = UdsModalService.createModal({
          controller: ShareFolderDialogController,
          modalName: 'shareFolderDialog',
          data: {
            collection: collection
          },
          onClose: null
        })

        shareFolderDialog.open()
      })
    }
  }
})()
